import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiNftAndWorldOverviewVariables = Types.Exact<{
  chainId: Types.Scalars['ChainId'];
  contractAddress: Types.Scalars['Address'];
  tokenId: Types.Scalars['Int'];
}>;


export type ApiNftAndWorldOverview = { nft: { name: string | null, chainId: ChainId, saleStartsAt: string | null, activeAuction: { duration: number, state: Types.ApiAuctionState, reservePrice: number } | null, activeBuyNow: { amount: number } | null, collection: { name: string, collectionImageUrl: string | null }, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | null, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null };



export const ApiNftAndWorldOverviewDocument = /*#__PURE__*/ `
    query NftAndWorldOverview($chainId: ChainId!, $contractAddress: Address!, $tokenId: Int!) {
  nft: nftV2(
    nft: {chainId: $chainId, contractAddress: $contractAddress, tokenId: $tokenId}
  ) {
    name
    chainId
    activeAuction {
      duration
      state
      reservePrice
    }
    activeBuyNow {
      amount
    }
    collection {
      name
      collectionImageUrl
    }
    creator {
      ...UserLightFragment
    }
    media {
      ...MediaFragment
    }
    saleStartsAt
  }
  world(
    by: {nft: {chainId: $chainId, contractAddress: $contractAddress, tokenId: $tokenId}}
  ) {
    ...WorldOverviewFragment
  }
}
    ${UserLightFragment}
${MediaFragment}
${WorldOverviewFragment}`;

export const useNftAndWorldOverview = <
      TData = ApiNftAndWorldOverview,
      TError = ClientError
    >(
      variables: ApiNftAndWorldOverviewVariables,
      options?: Omit<UseQueryOptions<ApiNftAndWorldOverview, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiNftAndWorldOverview, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiNftAndWorldOverview, TError, TData>(
      {
    queryKey: ['NftAndWorldOverview', variables],
    queryFn: apiFetcher<ApiNftAndWorldOverview, ApiNftAndWorldOverviewVariables>(ApiNftAndWorldOverviewDocument, variables),
    ...options
  }
    )};

useNftAndWorldOverview.getKey = (variables: ApiNftAndWorldOverviewVariables) => ['NftAndWorldOverview', variables];

export const useInfiniteNftAndWorldOverview = <
      TData = InfiniteData<ApiNftAndWorldOverview>,
      TError = ClientError
    >(
      variables: ApiNftAndWorldOverviewVariables,
      options: Omit<UseInfiniteQueryOptions<ApiNftAndWorldOverview, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiNftAndWorldOverview, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiNftAndWorldOverview, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NftAndWorldOverview.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiNftAndWorldOverview, ApiNftAndWorldOverviewVariables>(ApiNftAndWorldOverviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNftAndWorldOverview.getKey = (variables: ApiNftAndWorldOverviewVariables) => ['NftAndWorldOverview.infinite', variables];


useNftAndWorldOverview.fetcher = (variables: ApiNftAndWorldOverviewVariables, options?: RequestInit['headers']) => apiFetcher<ApiNftAndWorldOverview, ApiNftAndWorldOverviewVariables>(ApiNftAndWorldOverviewDocument, variables, options);
